import { RolesApiDTO } from "./shared.models.api.dto";
import { UserRoleType } from "@/models/user";

// will be used on oauth migration
export const mapperRoletDtoToRole = (roleDTO: RolesApiDTO): UserRoleType => {
  return roleDTO;
};
